<template>
    <div class="mb-3">
        <h3 class="required-field">Signature Panel<label></label></h3>
    <div class="signature-container">
        <div class="row">
            <div class="col-md-6">
                <VueSignaturePad
                        id="signature"
                        ref="signaturePad"
                        :options="{ options, onEnd }"
                />
                <span class="clearIcon" title="Clear" @click="clear">Clear</span>
                <span class="signature-text">Signature</span>
            </div>
            <div class="col-md-6">
                <div class="row">
                    <div class="col-md-12">
                        <b-form-input
                                v-model="name"
                                v-validate="{regex: allExceptSpecialCharacters}"
                                type="text"
                                placeholder="Name"
                                :disabled="isCheckDisable"
                                @input="updateValue('name',$event)"
                        ></b-form-input>
                    </div>
                    <div class="col-md-12">
                        <b-form-input
                                v-model="position"
                                v-validate="{regex: allExceptSpecialCharacters}"
                                type="text"
                                placeholder="Position"
                                :disabled="isCheckDisable"
                                @input="updateValue('position',$event)"
                        ></b-form-input>
                    </div>
                    <div class="col-md-12">
                        <div class="custom-datepicker">
                        <date-picker
                                v-model="date"
                                class="form-control"
                                format="DD-MM-YYYY"
                                lang="en"
                                :disabled="isCheckDisable"
                                @input="updateValue('date',$event)"
                        ></date-picker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
        <div class="row">
            <div class="col-md-12 mt-2">
                    <b-form-checkbox  v-model="agree" @input="agreeValue()">
                        I understand that electronically signing this form constitutes a legally binding signature
                    </b-form-checkbox>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from 'vue2-datepicker'

    export default {
        components: {
            DatePicker,
        },
        name: "App",
        data: () => ({
            options: {
                penColor: "#000",
                minWidth:3,
                minHeight:5,
                width:50
            },
            allExceptSpecialCharacters: /^[^!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]*$/,
            isCheckDisable:true,
            name:'',
            position:'',
            date:null,
            agree:false,
            isEmpty:true
            // sign:this.$store.getters.form.signature.sign
        }),
        async mounted() {
            fetch(this.$store.getters.form.signature.sign)
                .then((raw) => raw.blob())
                .then((blob) => {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = () => {
                        this.$refs.signaturePad.fromDataURL(reader.result);
                    };
                });
        },
        methods: {
            onEnd() {
                this.save()
            },
            agreeValue()
            {
                this.$store.commit('updateField', {
                    key: `signature.agree`,
                    value: this.agree,
                })
            },
            updateValue(key,index)
            {
                this.$store.commit('updateField', {
                    key: `signature.${key}`,
                    value: index,
                })
                // console.log('value & key',index,key)
                // console.log('value',this.$store.getters.form.signature)
            },
            clear() {
                this.$refs.signaturePad.clearSignature();
                this.$store.commit('updateField', {
                    key: `signature.sign`,
                    value: '',
                })
                this.isCheckDisable=true
                this.agree=false
                this.date=null
                this.name=null
                this.position=null

                this.$store.commit('updateField', {
                    key: `signature.name`,
                    value: this.name,
                })
                this.$store.commit('updateField', {
                    key: `signature.position`,
                    value: this.position,
                })
                this.$store.commit('updateField', {
                    key: `signature.date`,
                    value: this.date,
                })
            },
            save() {
                const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
                if(!isEmpty)
                {
                    this.$store.commit('updateField', {
                        key: `signature.sign`,
                        value: data,
                    })
                    this.isEmpty=false
                    this.isCheckDisable=false
                }
            },
        },
    };
</script>

<style>
    #signature {
        background-origin: border-box;
        background-clip: content-box, border-box;
    }

    .signature-container
    {
        border: 1px solid grey;
        border-radius: 5px;
    }
    .clearIcon
    {
        background: lightgray;
        color: white;
        padding-right: 7px;
        padding-left: 7px;
        cursor: pointer;
        position: absolute;
        bottom: 0%;
        border-bottom-left-radius: 4px;
    }
    .signature-text
    {
        padding-left: 8px;
        position: absolute;
        top: 0%;
    }
</style>
